<template>
  <div class="card">
    <div class="row" v-if="!serviceStatusLoading">
      <!-- Service Status Starts -->
      <div class="col-md-8 col-12 order-summary border-right pr-md-0">
        <div class="card mb-0">
          <div
            class="
              card-header
              d-flex
              justify-content-between
              align-items-center
            "
          >
            <h4 class="card-title">{{ $t("dashboard.service_status") }}</h4>
            <div class="d-flex">
              <button
                type="button"
                class="btn btn-sm btn-light-primary glow"
                @click="onChangeDay()"
              >
                {{ $t("dashboard.days") }}
              </button>
              <button
                type="button"
                class="btn btn-sm btn-light-primary ml-1"
                @click="onChangeYear()"
              >
                {{ $t("dashboard.years") }}
              </button>
            </div>
          </div>
          <div
            class="card-body p-0"
            style="position: relative"
            v-if="chartOptions"
          >
            <apexchart
              height="400"
              type="bar"
              :options="chartOptions.options"
              :series="chartOptions.series"
            >
            </apexchart>
          </div>
        </div>
      </div>
      <!-- Service Status End -->

      <!-- Service Counts Starts -->
      <div class="col-md-4 col-12 pl-md-0" >
        <div class="card mb-0">
          <div class="card-header pb-50">
            <h4 class="card-title">{{ $t("dashboard.service_status") }}</h4>
          </div>
          <div class="card-body py-1">
            <div
              class="
                d-flex
                justify-content-between
                align-items-center
                mb-1
                mt-2
              "
            >
              <div class="sales-item-name">
                <p class="mb-0">{{ $t("dashboard.service_waiting_count") }}</p>
                <small class="text-muted">{{ $t("dashboard.total") }}</small>
              </div>
              <h6 class="mb-0">{{ waitingServiceCount }}</h6>
            </div>

            <div class="d-flex justify-content-between align-items-center mt-2">
              <div class="sales-item-name">
                <p class="mb-0">{{ $t("dashboard.service_ongoing_count") }}</p>
                <small class="text-muted">{{ $t("dashboard.total") }}</small>
              </div>
              <h6 class="mb-0">{{ onGoingServiceCount }}</h6>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-2">
              <div class="sales-item-name">
                <p class="mb-0">
                  {{ $t("dashboard.service_completed_count") }}
                </p>
                <small class="text-muted">{{ $t("dashboard.total") }}</small>
              </div>
              <h6 class="mb-0">{{ completedServiceCount }}</h6>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-2">
              <div class="sales-item-name">
                <p class="mb-0">{{ $t("dashboard.service_total_count") }}</p>
                <small class="text-muted">{{ $t("dashboard.total") }}</small>
              </div>
              <h6 class="mb-0">{{ totalServiceCount }}</h6>
            </div>
          </div>
        </div>
      </div>
      <!-- Service Counts End -->
    </div>
    <div class="row" v-else>
      <div class="col-12">
      <loading-box></loading-box>  
      </div>

    </div>
  </div>
</template>
  
<script>
import VueApexCharts from "vue-apexcharts";
import LoadingBox from "@/assets/components/loader/LoadingBox";
import moment from "moment";

import baseModule, {
  ERROR,
  SERVICES,
  GET_SERVICES,
  MODULE_NAME,
  SUCCESS,
  GET_SERVICE_STATUS_LOADING,
} from "@/core/services/store/dashboard.module";
import store from "@/core/services/store";

const _MODULE_NAME = MODULE_NAME;

export default {
  name: "DashboardServices",
  components: {
    VueApexCharts,
    LoadingBox
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }
    registerStoreModule(_MODULE_NAME, baseModule);
  },
  data() {
    return {};
  },
  computed: {
    error() {
      return store.getters[_MODULE_NAME + "/" + ERROR];
    },
    serviceStatusLoading() {
      return store.getters[_MODULE_NAME + "/" + GET_SERVICE_STATUS_LOADING];
    },
    success() {
      return store.getters[_MODULE_NAME + "/" + SUCCESS];
    },
    services() {
      return store.getters[_MODULE_NAME + "/" + SERVICES];
    },
    chartOptions() {
      let chartData = this.services;
      if (!chartData) return null;

      let self = this;
      let $primary = "#5A8DEE";
      let $gray_light = "#828D99";

      let categories = [];
      let data = [];

      if (chartData.type === "day") {
        for (let i = 0; i < 30; i++) {
          let dayTime = moment().subtract(i, "day");
          let day = dayTime.format("DD");
          let dayFull = dayTime.format("DD-MM-YYYY");
          let chartItem = chartData.chartData.find(
            (item) => +item.day === +day
          );

          if (chartItem) {
            categories.push(dayFull);
            data.push(chartItem.service_count);
          }
        }
      } else if (chartData.type === "years") {

        for (let i = 0; i < 15; i++) {
          let yearTime = moment().subtract(i, "year");
          let year = yearTime.format("YYYY");
          let yearFull = yearTime.format("YYYY");
          let chartItem = chartData.chartData.find((item) => item.year == year);
          if (chartItem) {
            categories.push(yearFull);
            data.push(chartItem.service_count);
          }
        }
      }

      return {
        options: {
          chart: {
            height: 260,
            width: "100%",
            type: "bar",
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "20%",
              endingShape: "rounded",
            },
          },
          dataLabels: {
            enabled: false,
          },
          colors: [$primary],
          fill: {
            type: "gradient",
            gradient: {
              shade: "light",
              type: "vertical",
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
            },
          },
          xaxis: {
            categories: categories,
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
            labels: {
              style: {
                colors: $gray_light,
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                color: $gray_light,
              },
              formatter: function (val) {
                return val ? +val.toFixed(0) : 0;
              },
            },
          },
          legend: {
            show: false,
          },
        },
        series: [
          {
            name: self.$t("dashboard.service_count"),
            data: data,
          },
        ],
      };
    },
    waitingServiceCount() {
      let serviceData = this.services;
      if (!serviceData) return 0;

      return _.sumBy(
        serviceData.counts.filter((item) => item.service_status_id === 1),
        "service_count"
      );
    },
    onGoingServiceCount() {
      let serviceData = this.services;
      if (!serviceData) return 0;

      return _.sumBy(
        serviceData.counts.filter(
          (item) =>
            !(item.service_status_id === 1 || item.service_status_id === 9)
        ),
        "service_count"
      );
    },
    completedServiceCount() {
      let serviceData = this.services;
      if (!serviceData) return 0;

      return _.sumBy(
        serviceData.counts.filter((item) => item.service_status_id === 9),
        "service_count"
      );
    },
    totalServiceCount() {
      let serviceData = this.services;
      if (!serviceData) return 0;

      return _.sumBy(serviceData.counts, "service_count");
    },
  },
  mounted() {
    this.filterResults();
  },
  methods: {
    filterResults() {
      this.$store.dispatch(_MODULE_NAME + "/" + GET_SERVICES, {});
    },
    async onChangeDay() {
      await this.$store.dispatch(_MODULE_NAME + "/" + GET_SERVICES, {});
      this.chartOptions;
    },
    async onChangeYear() {
      await this.$store.dispatch(_MODULE_NAME + "/" + GET_SERVICES, {
        filters: {
          years: true,
        },
      });
      this.chartOptions;
    },
    getData() {
      this.onGoingServiceCount = null;
      this.completedServiceCount = null;
      this.totalServiceCount = null;
      this.waitingServiceCount = null;
      let serviceData = this.services;
      if (!serviceData) return 0;

      this.totalServiceData = _.sumBy(
        serviceData.counts.filter((item) => item.service_status_id === 1),
        "service_count"
      );

      this.waitingServiceCount = _.sumBy(
        serviceData.counts.filter((item) => item.service_status_id === 1),
        "service_count"
      );

      this.onGoingServiceCount = _.sumBy(
        serviceData.counts.filter(
          (item) =>
            !(item.service_status_id === 1 || item.service_status_id === 9)
        ),
        "service_count"
      );
      this.completedServiceCount = _.sumBy(
        serviceData.counts.filter((item) => item.service_status_id === 9),
        "service_count"
      );

      this.totalServiceCount = _.sumBy(serviceData.counts, "service_count");
    },
  },
};
</script>
    
